// src/components/Dashboard.js
import React, { useState ,useEffect} from 'react';
import './Dashboard.css';
import AddPurchase from './AddPurchase';
import AddSale from './AddSale';    
import CategoryForm from './CategoryForm';
import api from '../Service/api';
import ViewPurchases from "./ViewPurchases";
import ViewSales from "./viewSales";
import RevertStock from './RevertStock';
import ViewPurchaseReturn from './ViewPurchaseReturn';
import SaleRevertStock from './SaleRevertStock';
import ViewSalesReturn from './ViewSalesReturn';
import InventoryPage from './InventoryPage';
import CustomerPaymentsPage from './CustomerPaymentsPage';
import CompanyPaymentsPage from './CompanyPaymentsPage';
import PayBill from './PayBill';
import CustomerPayBill from './CustomerPayBill';
import CustomerLedger from './CustomerLedger';
import VendorLedger from './VendorLedger';
import DailyExpenses from './DailyExpenses';
import ExpenseCategories from './ExpenseCategories';
import ExpensesByDate from './ExpensesByDate';
import EmployeeManagement from './EmployeeManagement';
import EmployeeView from './EmployeeView';
import EmployeeSalaryManagement from './EmployeeSalaryManagement';
import EmployeeSalaryView from './EmployeeSalaryView';
import Monthly from './Monthly';
import AddClientRequirement from './AddClientRequirement';
import ViewClientRequirements from './ViewClientRequirements';
import ProductionDashboard from './ProductionDashboard';
import OwnerAddProduct from './OwnerAddProduct';
import EmployeeProduction from './EmployeeProduction';
import CreateEmployee from './CreateEmployee';
import DailyInvoiceView from './DailyInvoiceView';
import ProductLedger from './ProductLedger';
import EmployeeAuthorityManager from './EmployeeAuthorityManager';
import CreateOrder from './CreateOrder';
import ViewCompletedOrders from './ViewCompleteOrders';
import ViewDeliveryChalan from './ViewDeliveryChalan';
import CostCalculator from './CostCalculator';
import FactoryUse  from './FactoryUse';
import ViewFactoryUse from './ViewFactoryUse';
import {
  FaHome,
  FaShoppingCart,
  FaCashRegister,
  FaChartLine,
  FaThList,
  FaUsers,
  FaMoneyCheckAlt,
  FaWallet,
  FaUserTie,
  FaSignOutAlt,
  FaIndustry,
  FaClipboardList
} from "react-icons/fa";

function Dashboard() {
  const [page, setPage] = useState('Monthly');
  const [categoryDropdown, setCategoryDropdown] = useState(false);
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [purchaseDropdown, setPurchaseDropdown] = useState(false);
  const [addPurchaseDropdown, setAddPurchaseDropdown] = useState(false);
  const [returnPurchaseDropdown, setReturnPurchaseDropdown] = useState(false);

  // Editing states
  const [editCategory, setEditCategory] = useState(null);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [editProduct, setEditProduct] = useState(null);
  const [newProductName, setNewProductName] = useState('');
  const [newPurchasePrice, setNewPurchasePrice] = useState('');
  const [newSellPrice, setNewSellPrice] = useState('');

  const [expensesDropdown, setExpensesDropdown] = useState(false);
  const [employeeDropdown, setEmployeeDropdown] = useState(false);
  const [requirementDropdown, setRequirementDropdown] = useState(false);
  const [inventoryDropdown, setInventoryDropdown] = useState(false);
  const [LoginDropdown, setLoginDropdown] = useState(false);
  const [OrderDropdown, setOrderDropdown] = useState(false);
  const [ProductionDropdown, setProductionDropdown] = useState(false);
  const [vendorDropdown, setVendorDropdown] = useState(false);

  const [vendorName, setVendorName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [vendorAddress, setVendorAddress] = useState('');
  const [vendorList, setVendorList] = useState([]);
  const [vendorSearch, setVendorSearch] = useState('');
  const [vendorSubDropdown, setVendorSubDropdown] = useState(false);
  const [customerSubDropdown, setCustomerSubDropdown] = useState(false);

  const [customerName, setCustomerName] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');
  const [customerList, setCustomerList] = useState([]);
  const [customerSearch, setCustomerSearch] = useState('');

  const [payBillDropdown, setPayBillDropdown] = useState(false);
  const [vendorBillDropdown, setVendorBillDropdown] = useState(false);
  const [customerBillDropdown, setCustomerBillDropdown] = useState(false);

  const [saleDropdown, setSaleDropdown] = useState(false);
  const [addSaleDropdown, setAddSaleDropdown] = useState(false);
  const [returnSaleDropdown, setReturnSaleDropdown] = useState(false);

  const [productCategoryDropdown, setProductCategoryDropdown] = useState(false);
  const [expenseCategoryDropdown, setExpenseCategoryDropdown] = useState(false);

  const [authorities, setAuthorities] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Helper function for authority checks
  const hasAuthority = (authName) => {
    return authorities.includes(authName.toUpperCase());
  };

  // Helper for "any of these authorities"
  const hasAnyAuthority = (authList) => {
    return authList.some(auth => authorities.includes(auth.toUpperCase()));
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  useEffect(() => {
    if (mobileMenuOpen && window.innerWidth <= 768) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }
    return () => {
      document.body.classList.remove('sidebar-open');
    };
  }, [mobileMenuOpen]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [mobileMenuOpen]);
  
  useEffect(() => {
    const auths = JSON.parse(localStorage.getItem('authorities') || '[]');
    console.log('=== DASHBOARD LOAD ===');
    console.log('Authorities from localStorage:', auths);
    setAuthorities(auths.map(a => a.toUpperCase()));
  }, []);

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      try {
        const token = localStorage.getItem('sessionToken');
        if (token) {
          await api.delete('/logout', { params: { token } });
        }
        localStorage.removeItem('sessionToken');
        localStorage.removeItem('tenantId');
        localStorage.removeItem('sessionExpiry');
        delete api.defaults.headers.common['Authorization'];
        delete api.defaults.headers.common['X-TENANTID'];
        window.location.href = '/login';
      } catch (error) {
        console.error('Logout error:', error);
        localStorage.clear();
        window.location.href = '/login';
      }
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await api.get('/api/category/getCategories');
      const data = res.data || res;
      let categoriesArray = [];
      if (data.additionalDetail) {
        categoriesArray = Array.isArray(data.additionalDetail)
          ? data.additionalDetail
          : [data.additionalDetail];
      }
      setCategories(categoriesArray);
      setFilteredCategories(categoriesArray);
      setPage('ViewCategories');
      setSearchText('');
    } catch (err) {
      console.error('Failed to fetch categories', err);
      alert('Failed to fetch categories');
    }
  };

  const toggleDropdown = () => {
    setCategoryDropdown(!categoryDropdown);
  };

  const updateCategory = async () => {
    if (!editCategory) return;
    try {
      await api.put(
        `/api/category/updateCategory/${editCategory.id}`,
        { categoryName: newCategoryName }
      );
      alert('Category updated');
      setEditCategory(null);
      fetchCategories();
    } catch (err) {
      console.error('Update category failed', err);
      alert('Failed to update category');
    }
  };

  const updateProduct = async () => {
    if (!editProduct) return;
    try {
      const body = {
        productName: newProductName,
        purchasePrice: Number(newPurchasePrice),
        sellPrice: Number(newSellPrice),
      };
      await api.put(
        `/api/category/updateProductNameOrPrice/${editProduct.id}`,
        body
      );
      alert('Product updated');
      setEditProduct(null);
      fetchCategories();
    } catch (err) {
      console.error('Update product failed', err);
      alert('Failed to update product');
    }
  };

  const handleSearchChange = (value) => {
    setSearchText(value);
    const filtered = categories.filter(cat =>
      (cat.categoryName || '').toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCategories(filtered);
  };

  const addVendor = async () => {
    try {
      const body = { vendorName, phoneNumber, address: vendorAddress };
      const res = await api.post('/product/vendor-name', body);
      alert(res.data.additionalDetail);
      setVendorName('');
      setPhoneNumber('');
      setVendorAddress('');
    } catch (err) {
      console.error("Add Vendor Error", err);
      alert("Failed to add vendor");
    }
  };

  const fetchVendors = async () => {
    try {
      const res = await api.get('/product/getAll');
      const data = res.data.additionalDetail || [];
      setVendorList(Array.isArray(data) ? data : [data]);
    } catch (err) {
      console.error("Get Vendor Error", err);
      alert("Failed to fetch vendors");
    }
  };

  const AddCustomer = async () => {
    try {
      const body = { customerName, phoneNumber, address: customerAddress };
      const res = await api.post('/product/customer-name', body);
      alert(res.data.additionalDetail);
      setCustomerName('');
      setPhoneNumber('');
      setCustomerAddress('');
    } catch (err) {
      console.error("Add Customer Error", err);
      alert("Failed to add customer");
    }
  };

  const fetchCustomers = async () => {
    try {
      const res = await api.get('/product/getAllCustomers');
      if (res.data && res.data.code === 1) {
        const data = res.data.additionalDetail || [];
        setCustomerList(Array.isArray(data) ? data : [data]);
      } else {
        alert(res.data.additionalDetail);
        setCustomerList([]);
      }
    } catch (err) {
      console.error("Get Customer Error", err);
      const errorMsg = err.response?.data?.message || err.response?.data?.additionalDetail || 'Failed to fetch customers';
      alert(errorMsg);
      setCustomerList([]);
    }
  };

  return (
    <div className="dashboard-container">
      <div className="mobile-header">
        <span className="logo-text">POS System</span>
        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
      </div>

      {mobileMenuOpen && window.innerWidth <= 768 && (
        <div className="sidebar-overlay visible" onClick={() => setMobileMenuOpen(false)} />
      )}

      <aside className={`sidebar ${mobileMenuOpen ? 'expanded' : 'collapsed'}`}>
        <h2 className="logo">POS System</h2>
        <ul className="menu">

          {/* HOME - Ye ab dikhega */}
          {hasAuthority("HOME") && (
            <li
              className={`menu-item ${page === "Monthly" ? "active" : ""}`}
              onClick={() => setPage("Monthly")}
            >
              <FaHome /> Home
            </li>
          )}

          {/* PURCHASES - Main Menu - FIXED: PURCHASES instead of PURCHASE */}
          {hasAnyAuthority(["PURCHASES", "ADD_PURCHASE", "ENTER_PURCHASE", "VIEW_PURCHASE", 
                           "RETURN_PURCHASE", "ENTER_PURCHASE_RETURN", "VIEW_PURCHASE_RETURN"]) && (
            <li className="menu-item" onClick={() => setPurchaseDropdown(!purchaseDropdown)}>
              <FaShoppingCart /> Purchases <span>{purchaseDropdown}</span>
            </li>
          )}

          {purchaseDropdown && (
            <ul className="submenu">
              {/* Add Purchase Section */}
              {hasAnyAuthority(["ADD_PURCHASE", "ENTER_PURCHASE", "VIEW_PURCHASE"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setAddPurchaseDropdown(!addPurchaseDropdown)}
                  >
                    Add Purchase <span>{addPurchaseDropdown ? '▲' : '▼'}</span>
                  </li>
                  {addPurchaseDropdown && (
                    <ul className="submenu nested-submenu">
                      {hasAuthority("ENTER_PURCHASE") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('purchases')}
                        >
                          Enter Purchase
                        </li>
                      )}
                      {hasAuthority("VIEW_PURCHASE") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('viewPurchases')}
                        >
                          View Purchase
                        </li>
                      )}
                    </ul>
                  )}
                </>
              )}

              {/* Return Purchase Section */}
              {hasAnyAuthority(["RETURN_PURCHASE", "ENTER_PURCHASE_RETURN", "VIEW_PURCHASE_RETURN"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setReturnPurchaseDropdown(!returnPurchaseDropdown)}
                  >
                    Return Purchase <span>{returnPurchaseDropdown ? '▲' : '▼'}</span>
                  </li>
                  {returnPurchaseDropdown && (
                    <ul className="submenu nested-submenu">
                      {hasAuthority("ENTER_PURCHASE_RETURN") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('RevertStock')}
                        >
                          Enter Return
                        </li>
                      )}
                      {hasAuthority("VIEW_PURCHASE_RETURN") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('ViewPurchaseReturn')}
                        >
                          View Return
                        </li>
                      )}
                    </ul>
                  )}
                </>
              )}
            </ul>
          )}

          {/* SALES - Main Menu */}
          {hasAnyAuthority(["SALES", "ADD_SALE", "ENTER_SALE", "VIEW_SALE", "RETURN_SALE",
                           "ENTER_SALE_RETURN", "VIEW_SALE_RETURN", "VIEW_DELIVERY_CHALAN", "FACTORY_USE", "ViewFactoryUse"]) && (
            <li className="menu-item" onClick={() => setSaleDropdown(!saleDropdown)}>
              <FaCashRegister /> Sales <span>{saleDropdown}</span>
            </li>
          )}

          {saleDropdown && (
            <ul className="submenu">
              {/* Add Sale Section */}
              {hasAnyAuthority(["ADD_SALE", "ENTER_SALE", "VIEW_SALE", "VIEW_DELIVERY_CHALAN","FACTORY_USE","ViewFactoryUse"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setAddSaleDropdown(!addSaleDropdown)}
                  >
                    Add Sale <span>{addSaleDropdown ? '▲' : '▼'}</span>
                  </li>
                  {addSaleDropdown && (
                    <ul className="submenu nested-submenu">
                      {hasAuthority("ENTER_SALE") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('sales')}
                        >
                          Enter Sale
                        </li>
                      )}
                      
                      {hasAuthority("VIEW_SALE") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('viewSales')}
                        >
                          View Sale
                        </li>
                      )}

                      {hasAuthority("FACTORY_USE") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('FactoryUse')}
                        >
                          Enter Factory Use
                        </li>
                      )}

                      {hasAuthority("VIEW_FACTORY_USE") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('ViewFactoryUse')}
                        >
                          View Factory Use
                        </li>
                      )}
                      {hasAuthority("VIEW_DELIVERY_CHALAN") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('ViewDeliveryChalan')}
                        >
                          View Delivery Chalan
                        </li>
                      )}
                    </ul>
                  )}
                </>
              )}

              {/* Return Sale Section */}
              {hasAnyAuthority(["RETURN_SALE", "ENTER_SALE_RETURN", "VIEW_SALE_RETURN"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setReturnSaleDropdown(!returnSaleDropdown)}
                  >
                    Return Sale <span>{returnSaleDropdown ? '▲' : '▼' }</span>
                  </li>
                  {returnSaleDropdown && (
                    <ul className="submenu nested-submenu">
                      {hasAuthority("ENTER_SALE_RETURN") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('SaleRevertStock')}
                        >
                          Enter Return
                        </li>
                      )}
                      {hasAuthority("VIEW_SALE_RETURN") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('ViewSalesReturn')}
                        >
                          View Return
                        </li>
                      )}
                    </ul>
                  )}
                </>
              )}
            </ul>
          )}

          {/* CATEGORIES - Main Menu */}
          {hasAnyAuthority(["CATEGORIES", "PRODUCT", "ADD_CATEGORY", "VIEW_CATEGORIES", 
                           "EXPENSE", "ADD & VIEW"]) && (
            <li className="menu-item" onClick={toggleDropdown}>
              <FaThList /> Categories <span>{categoryDropdown}</span>
            </li>
          )}

          {categoryDropdown && (
            <ul className="submenu">
              {/* Product Categories */}
              {hasAnyAuthority(["PRODUCT", "ADD_CATEGORY", "VIEW_CATEGORIES"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setProductCategoryDropdown(!productCategoryDropdown)}
                  >
                    Product <span>{productCategoryDropdown ? '▲' : '▼'}</span>
                  </li>
                  {productCategoryDropdown && (
                    <ul className="submenu nested-submenu">
                      {hasAuthority("ADD_CATEGORY") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('AddCategory')}
                        >
                          Add Category
                        </li>
                      )}
                      {hasAuthority("VIEW_CATEGORIES") && (
                        <li
                          className="submenu-item"
                          onClick={fetchCategories}
                        >
                          View Categories
                        </li>
                      )}
                      <li
                          className="submenu-item"
                          onClick={() => setPage('CostCalculator')}
                        >
                           Cost Calculator
                        </li>
                    </ul>
                  )}
                </>
              )}

              {/* Expense Categories */}
              {hasAnyAuthority(["EXPENSE", "ADD & VIEW"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setExpenseCategoryDropdown(!expenseCategoryDropdown)}
                  >
                    Expense <span>{expenseCategoryDropdown ? '▲' : '▼'}</span>
                  </li>
                  {expenseCategoryDropdown && (
                    <ul className="submenu nested-submenu">
                      {hasAuthority("ADD & VIEW") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('ExpenseCategories')}
                        >
                          Add & View
                        </li>
                      )}
                    </ul>
                  )}
                </>
              )}
            </ul>
          )}

          {/* VENDORS & CUSTOMERS - Main Menu */}
          {hasAnyAuthority(["VENDORS&CUSTOMERS", "VENDORS", "ADD_VENDOR", "VIEW_VENDORS",
                           "CUSTOMERS", "ADD_CUSTOMER", "VIEW_CUSTOMERS"]) && (
            <li className="menu-item" onClick={() => setVendorDropdown(!vendorDropdown)}>
              <FaUsers /> Vendors & Customers <span>{vendorDropdown }</span>
            </li>
          )}

          {vendorDropdown && (
            <ul className="submenu">
              {/* Vendors Section */}
              {hasAnyAuthority(["VENDORS", "ADD_VENDOR", "VIEW_VENDORS"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setVendorSubDropdown(!vendorSubDropdown)}
                  >
                    Vendor <span>{vendorSubDropdown ? '▲' : '▼'}</span>
                  </li>
                  {vendorSubDropdown && (
                    <ul className="sub-submenu">
                      {hasAuthority("ADD_VENDOR") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('AddVendor')}
                        >
                          Add Vendor
                        </li>
                      )}
                      {hasAuthority("VIEW_VENDORS") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('ViewVendors')}
                        >
                          View Vendors
                        </li>
                      )}
                    </ul>
                  )}
                </>
              )}

              {/* Customers Section */}
              {hasAnyAuthority(["CUSTOMERS", "ADD_CUSTOMER", "VIEW_CUSTOMERS"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setCustomerSubDropdown(!customerSubDropdown)}
                  >
                    Customer <span>{customerSubDropdown ? '▲' : '▼'}</span>
                  </li>
                  {customerSubDropdown && (
                    <ul className="sub-submenu">
                      {hasAuthority("ADD_CUSTOMER") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('AddCustomer')}
                        >
                          Add Customer
                        </li>
                      )}
                      {hasAuthority("VIEW_CUSTOMERS") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage('ViewCustomers')}
                        >
                          View Customers
                        </li>
                      )}
                    </ul>
                  )}
                </>
              )}
            </ul>
          )}

          {/* PAY BILLS - Main Menu */}
          {hasAnyAuthority(["PAY BILLS", "VENDOR_BILL", "PAY_VENDOR_BILL", "VIEW_VENDOR_BILLS",
                           "CUSTOMER_BILL", "RECEIVE_CUSTOMER_BILL", "VIEW_CUSTOMER_BILLS"]) && (
            <li className="menu-item" onClick={() => setPayBillDropdown(!payBillDropdown)}>
              <FaMoneyCheckAlt /> Pay Bills <span>{payBillDropdown}</span>
            </li>
          )}

          {payBillDropdown && (
            <ul className="submenu">
              {/* Vendor Bill Section */}
              {hasAnyAuthority(["VENDOR_BILL", "PAY_VENDOR_BILL", "VIEW_VENDOR_BILLS"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setVendorBillDropdown(!vendorBillDropdown)}
                  >
                    Vendor Bill <span>{vendorBillDropdown ? '▲' : '▼'}</span>
                  </li>
                  {vendorBillDropdown && (
                    <ul className="sub-submenu">
                      {hasAuthority("PAY_VENDOR_BILL") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage("PayBill")}
                        >
                          Pay Bill
                        </li>
                      )}
                      {hasAuthority("VIEW_VENDOR_BILLS") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage("CompanyPaymentsPage")}
                        >
                          View Bill Payed
                        </li>
                      )}
                    </ul>
                  )}
                </>
              )}

              {/* Customer Bill Section */}
              {hasAnyAuthority(["CUSTOMER_BILL", "RECEIVE_CUSTOMER_BILL", "VIEW_CUSTOMER_BILLS"]) && (
                <>
                  <li
                    className="submenu-item"
                    onClick={() => setCustomerBillDropdown(!customerBillDropdown)}
                  >
                    Customer Bill <span>{customerBillDropdown ? '▲' : '▼'}</span>
                  </li>
                  {customerBillDropdown && (
                    <ul className="sub-submenu">
                      {hasAuthority("RECEIVE_CUSTOMER_BILL") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage("CustomerPayBill")}
                        >
                        Receive Payment
                        </li>
                      )}
                      {hasAuthority("VIEW_CUSTOMER_BILLS") && (
                        <li
                          className="submenu-item"
                          onClick={() => setPage("CustomerPaymentsPage")}
                        >
                          View Payments
                        </li>
                      )}
                    </ul>
                  )}
                </>
              )}
            </ul>
          )}

          {/* EXPENSES - Main Menu */}
          {hasAnyAuthority(["EXPENSES", "ADD_EXPENSE", "VIEW_EXPENSES"]) && (
            <li className="menu-item" onClick={() => setExpensesDropdown(!expensesDropdown)}>
              <FaWallet /> Expenses <span>{expensesDropdown}</span>
            </li>
          )}

          {expensesDropdown && (
            <ul className="submenu">
              {hasAuthority("ADD_EXPENSE") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('DailyExpenses')}
                >
                  Add Expenses
                </li>
              )}
              {hasAuthority("VIEW_EXPENSES") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('ExpensesByDate')}
                >
                  View Expenses
                </li>
              )}
            </ul>
          )}

          {/* EMPLOYEES - Main Menu */}
          {hasAnyAuthority(["EMPLOYEES", "ADD_EMPLOYEE_DETAILS", "VIEW_EMPLOYEES",
                           "PAY_SALARY", "VIEW_SALARIES"]) && (
            <li className="menu-item" onClick={() => setEmployeeDropdown(!employeeDropdown)}>
              <FaUserTie /> Employees <span>{employeeDropdown}</span>
            </li>
          )}

          {employeeDropdown && (
            <ul className="submenu">
              {hasAuthority("ADD_EMPLOYEE_DETAILS") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('EmployeeManagement')}
                >
                  Add Details
                </li>
              )}
              {hasAuthority("VIEW_EMPLOYEES") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('EmployeeView')}
                >
                  View Details
                </li>
              )}
              {hasAuthority("PAY_SALARY") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('EmployeeSalaryManagement')}
                >
                  Pay Salaries
                </li>
              )}
              {hasAuthority("VIEW_SALARIES") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('EmployeeSalaryView')}
                >
                  View Salaries
                </li>
              )}
            </ul>
          )}

          {/* CLIENT REQUIREMENTS - Main Menu */}
          {hasAnyAuthority(["CLIENT REQUIREMENTS", "ADD_REQUIREMENT", "VIEW_REQUIREMENTS"]) && (
            <li className="menu-item" onClick={() => setRequirementDropdown(!requirementDropdown)}>
              <FaClipboardList /> Client Requirements <span>{requirementDropdown}</span>
            </li>
          )}

          {requirementDropdown && (
            <ul className="submenu">
              {hasAuthority("ADD_REQUIREMENT") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('AddClientRequirement')}
                >
                  Add Requirements
                </li>
              )}
              {hasAuthority("VIEW_REQUIREMENTS") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('ViewClientRequirements')}
                >
                  View Requirements
                </li>
              )}
            </ul>
          )}

          {/* PRODUCTION - Main Menu */}
          {hasAnyAuthority(["PRODUCTION", "OWNER PRODUCTION", "OWNER DASHBOARD"]) && (
            <li className="menu-item" onClick={() => setProductionDropdown(!ProductionDropdown)}>
              <FaIndustry /> Production <span>{ProductionDropdown}</span>
            </li>
          )}

          {ProductionDropdown && (
            <ul className="submenu">
              {hasAuthority("OWNER PRODUCTION") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('OwnerAddProduct')}
                >
                  Add Product & Steps
                </li>
              )}
              
              <li
                className="submenu-item"
                onClick={() => window.location.href = '/employee-production'}
              >
                Employee Production Time
              </li>

              {hasAuthority("OWNER DASHBOARD") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('ProductionDashboard')}
                >
                  Production Report
                </li>
              )}
            </ul>
          )}

          {/* ORDERS - Main Menu */}
          {hasAnyAuthority(["ORDERS", "CREATE_ORDER", "VIEW_ORDERS"]) && (
            <li className="menu-item" onClick={() => setOrderDropdown(!OrderDropdown)}>
              <FaClipboardList /> Orders <span>{OrderDropdown}</span>
            </li>
          )}

          {OrderDropdown && (
            <ul className="submenu">
              {hasAuthority("CREATE_ORDER") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('CreateOrder')}
                >
                  Create Orders
                </li>
              )}
              {hasAuthority("VIEW_ORDERS") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('ViewCompleteOrders')}
                >
                  View Orders
                </li>
              )}
            </ul>
          )}

          {/* REPORTS - Main Menu */}
          {hasAnyAuthority(["REPORTS", "STOCK_INVENTORY", "CUSTOMER_LEDGER",
                           "VENDOR_LEDGER", "DAILY_INVOICE"]) && (
            <li className="menu-item" onClick={() => setInventoryDropdown(!inventoryDropdown)}>
              <FaChartLine /> Reports <span>{inventoryDropdown}</span>
            </li>
          )}

          {inventoryDropdown && (
            <ul className="submenu">
              {hasAuthority("STOCK_INVENTORY") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('InventoryPage')}
                >
                  Stock Inventory
                </li>
              )}
              {hasAuthority("CUSTOMER_LEDGER") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('CustomerLedger')}
                >
                  Customer Ledger
                </li>
              )}
              {hasAuthority("VENDOR_LEDGER") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('VendorLedger')}
                >
                  Vendor Ledger
                </li>
              )}
              {hasAuthority("DAILY_INVOICE") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('DailyInvoiceView')}
                >
                  Daily Invoice View
                </li>
              )}
              <li
                  className="submenu-item"
                  onClick={() => setPage('ProductLedger')}
                >
                  Product Ledger
                </li>
            </ul>
          )}

          {/* EMPLOYEE LOGIN MANAGEMENT - Main Menu */}
          {hasAnyAuthority(["EMPLOYEE LOGIN", "CREATE_EMPLOYEE_LOGIN", "MANAGE_AUTHORITIES"]) && (
            <li className="menu-item" onClick={() => setLoginDropdown(!LoginDropdown)}>
              <FaUserTie /> Create Employee Login <span>{LoginDropdown}</span>
            </li>
          )}

          {LoginDropdown && (
            <ul className="submenu">
              {hasAuthority("CREATE_EMPLOYEE_LOGIN") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('CreateEmployee')}
                >
                  Credentials & Authorities
                </li>
              )}
              {hasAuthority("MANAGE_AUTHORITIES") && (
                <li
                  className="submenu-item"
                  onClick={() => setPage('EmployeeAuthorityManager')}
                >
                  Employees Authority Manager
                </li>
              )}
            </ul>
          )}

          {/* LOGOUT - Always visible */}
          <li className="menu-item" onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </li>
        </ul>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        {/* Home Page - Ye ab dikhega */}
        {page === 'Monthly' && hasAuthority("HOME") && <h1>Welcome to POS Dashboard</h1>}

        {/* Sales Pages */}
        {page === 'sales' && hasAuthority("ENTER_SALE") && <AddSale />}
        {page === 'viewSales' && hasAuthority("VIEW_SALE") && <ViewSales />}
{page === 'FactoryUse' && hasAuthority("FACTORY_USE") && <FactoryUse />}
{page === 'ViewFactoryUse' && hasAuthority("VIEW_FACTORY_USE") && <ViewFactoryUse />}

        {page === 'SaleRevertStock' && hasAuthority("ENTER_SALE_RETURN") && <SaleRevertStock />}
        {page === 'ViewSalesReturn' && hasAuthority("VIEW_SALE_RETURN") && <ViewSalesReturn />}
        {page === 'ViewDeliveryChalan' && hasAuthority("VIEW_DELIVERY_CHALAN") && <ViewDeliveryChalan />}

        {/* Purchase Pages */}
        {page === 'purchases' && hasAuthority("ENTER_PURCHASE") && <AddPurchase />}
        {page === 'viewPurchases' && hasAuthority("VIEW_PURCHASE") && <ViewPurchases />}
        {page === 'RevertStock' && hasAuthority("ENTER_PURCHASE_RETURN") && <RevertStock />}
        {page === 'ViewPurchaseReturn' && hasAuthority("VIEW_PURCHASE_RETURN") && <ViewPurchaseReturn />}

        {/* Vendor Pages */}
        {page === 'AddVendor' && hasAuthority("ADD_VENDOR") && (
          <div className="form-card professional-card">
            <h2 className="form-title">Add New Vendor</h2>
            <input
              className="form-input professional-input"
              placeholder="Vendor Name"
              value={vendorName}
              onChange={(e) => setVendorName(e.target.value)}
            />
            <input
              className="form-input professional-input"
              placeholder="Contact Number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <input
              className="form-input professional-input"
              placeholder="Vendor Address"
              value={vendorAddress}
              onChange={(e) => setVendorAddress(e.target.value)}
            />
            <button className="primary-btn professional-btn" onClick={addVendor}>
              Save Vendor
            </button>
          </div>
        )}

        {page === 'ViewVendors' && hasAuthority("VIEW_VENDORS") && (
          <div className="table-card professional-card">
            <h2 className="table-title">Vendors List</h2>
            <div className="table-controls">
              <input
                className="search-input professional-input"
                placeholder="Search vendor..."
                value={vendorSearch}
                onChange={(e) => setVendorSearch(e.target.value)}
              />
              <button className="primary-btn professional-btn" onClick={fetchVendors}>
                Load Vendors
              </button>
            </div>
            <table className="purchase-table professional-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Vendor Name</th>
                  <th>Contact Number</th>
                  <th>Address</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {vendorList
                  .filter(v => v.vendorName?.toLowerCase().includes(vendorSearch.toLowerCase()))
                  .map(v => (
                    <tr key={v.id}>
                      <td>{v.id}</td>
                      <td>{v.vendorName || 'N/A'}</td>
                      <td>{v.phoneNumber || 'N/A'}</td>
                      <td>{v.address || 'N/A'}</td>
                      <td>
                        <div className="action-buttons">
                          
                            <button
                              className="update-btn"
                              onClick={async () => {
                                const newName = prompt("Enter new vendor name", v.vendorName);
                                const newNumber = prompt("Enter new contact number", v.phoneNumber);
                                const newAddress = prompt("Enter new vendor address", v.address);
                                if (!newName) return alert("Vendor name is required");
                                try {
                                  const res = await api.put(`/product/updateVendor/${v.id}`, {
                                    vendorName: newName,
                                    phoneNumber: newNumber || null,
                                    address: newAddress || null,
                                  });
                                  if (res.data?.code === 1) {
                                    alert(res.data.additionalDetail || "Vendor updated successfully");
                                    fetchVendors();
                                  } else {
                                    alert(res.data?.message || res.data?.additionalDetail || "Vendor update failed");
                                  }
                                } catch (err) {
                                  alert(err.response?.data?.message || "Vendor update failed");
                                }
                              }}
                            >
                              Update
                            </button>
                          
                        
                            <button
                              className="delete-btn"
                              onClick={async () => {
                                if (!window.confirm("Delete this vendor?")) return;
                                try {
                                  const res = await api.delete(`/product/deleteVendor/${v.id}`);
                                  if (res.data?.code === 1) {
                                    alert(res.data.additionalDetail || "Vendor deleted successfully");
                                    fetchVendors();
                                  } else {
                                    alert(res.data?.message || res.data?.additionalDetail || "Vendor delete failed");
                                  }
                                } catch (err) {
                                  alert(err.response?.data?.message || "Vendor delete failed");
                                }
                              }}
                            >
                              Delete
                            </button>
                          
                        </div>
                      </td>
                    </tr>
                  ))}
                {vendorList.length === 0 && (
                  <tr>
                    <td colSpan="5" className="no-data">No vendors found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Customer Pages */}
        {page === 'AddCustomer' && hasAuthority("ADD_CUSTOMER") && (
          <div className="form-card professional-card">
            <h2 className="form-title">Add New Customer</h2>
            <input
              className="form-input professional-input"
              placeholder="Customer Name"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />
            <input
              className="form-input professional-input"
              placeholder="Contact Number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <input
              className="form-input professional-input"
              placeholder="Customer Address"
              value={customerAddress}
              onChange={(e) => setCustomerAddress(e.target.value)}
            />
            <button className="primary-btn professional-btn" onClick={AddCustomer}>
              Save Customer
            </button>
          </div>
        )}

        {page === 'ViewCustomers' && hasAuthority("VIEW_CUSTOMERS") && (
          <div className="table-card professional-card">
            <h2 className="table-title">Customers List</h2>
            <div className="table-controls">
              <input
                type="text"
                placeholder="Search Customer..."
                value={customerSearch}
                onChange={(e) => setCustomerSearch(e.target.value)}
                className="search-input professional-input"
              />
              <button className="primary-btn professional-btn" onClick={fetchCustomers}>
                Load Customers
              </button>
            </div>
            <table className="purchase-table professional-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Customer Name</th>
                  <th>Contact Number</th>
                  <th>Address</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {customerList
                  .filter(c => c.customerName?.toLowerCase().includes(customerSearch.toLowerCase()))
                  .map(c => (
                    <tr key={c.id}>
                      <td>{c.id}</td>
                      <td>{c.customerName || 'N/A'}</td>
                      <td>{c.phoneNumber || 'N/A'}</td>
                      <td>{c.address || 'N/A'}</td>
                      <td>
                        <div className="action-buttons">
                          
                            <button
                              className="update-btn"
                              onClick={async () => {
                                const newName = prompt("Enter new customer name", c.customerName);
                                const newNumber = prompt("Enter new contact number", c.phoneNumber);
                                const newAddress = prompt("Enter new customer address", c.address);
                                if (!newName) return alert("Customer name is required");
                                try {
                                  const res = await api.put(`/product/updateCustomer/${c.id}`, {
                                    customerName: newName,
                                    phoneNumber: newNumber || null,
                                    address: newAddress || null,
                                  });
                                  if (res.data?.code === 1) {
                                    alert(res.data.additionalDetail || "Customer updated successfully");
                                    fetchCustomers();
                                  } else {
                                    alert(res.data?.message || res.data?.additionalDetail || "Customer update failed");
                                  }
                                } catch (err) {
                                  alert(err.response?.data?.message || "Customer update failed");
                                }
                              }}
                            >
                              Update
                            </button>
                        
                            <button
                              className="delete-btn"
                              onClick={async () => {
                                if (!window.confirm("Delete this Customer?")) return;
                                try {
                                  const res = await api.delete(`/product/deleteCustomer/${c.id}`);
                                  if (res.data?.code === 1) {
                                    alert(res.data.additionalDetail || "Customer deleted successfully");
                                    fetchCustomers();
                                  } else {
                                    alert(res.data?.message || res.data?.additionalDetail || "Customer delete failed");
                                  }
                                } catch (err) {
                                  alert(err.response?.data?.message || "Customer delete failed");
                                }
                              }}
                            >
                              Delete
                            </button>
                          
                        </div>
                      </td>
                    </tr>
                  ))}
                {customerList.length === 0 && (
                  <tr>
                    <td colSpan="5" className="no-data">No customers found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Other Pages */}
        {page === "InventoryPage" && hasAuthority("STOCK_INVENTORY") && <InventoryPage/>}
        {page === "CustomerPaymentsPage" && hasAuthority("VIEW_CUSTOMER_BILLS") && <CustomerPaymentsPage/>}
        {page === "CompanyPaymentsPage" && hasAuthority("VIEW_VENDOR_BILLS") && <CompanyPaymentsPage/>}
        {page === "PayBill" && hasAuthority("PAY_VENDOR_BILL") && <PayBill/>}
        {page === "CustomerPayBill" && hasAuthority("RECEIVE_CUSTOMER_BILL") && <CustomerPayBill/>}
        {page === "CustomerLedger" && hasAuthority("CUSTOMER_LEDGER") && <CustomerLedger/>}
        {page === "VendorLedger" && hasAuthority("VENDOR_LEDGER") && <VendorLedger/>}
        {page === "DailyExpenses" && hasAuthority("ADD_EXPENSE") && <DailyExpenses/>}
        {page === "ExpenseCategories" && hasAuthority("ADD & VIEW") && <ExpenseCategories/>}
        {page === "ExpensesByDate" && hasAuthority("VIEW_EXPENSES") && <ExpensesByDate/>}
        {page === "EmployeeManagement" && hasAuthority("ADD_EMPLOYEE_DETAILS") && <EmployeeManagement/>}
        {page === "EmployeeView" && hasAuthority("VIEW_EMPLOYEES") && <EmployeeView/>}
        {page === "EmployeeSalaryManagement" && hasAuthority("PAY_SALARY") && <EmployeeSalaryManagement/>}
        {page === "EmployeeSalaryView" && hasAuthority("VIEW_SALARIES") && <EmployeeSalaryView/>}
        {page === "AddClientRequirement" && hasAuthority("ADD_REQUIREMENT") && <AddClientRequirement/>}
        {page === "ViewClientRequirements" && hasAuthority("VIEW_REQUIREMENTS") && <ViewClientRequirements/>}
        {page === "OwnerAddProduct" && hasAuthority("OWNER PRODUCTION") && <OwnerAddProduct/>}
        {page === "EmployeeProduction" && <EmployeeProduction/>}
        {page === "ProductionDashboard" && hasAuthority("OWNER DASHBOARD") && <ProductionDashboard/>}
        {page === "CreateEmployee" && hasAuthority("CREATE_EMPLOYEE_LOGIN") && <CreateEmployee/>}
        {page === "DailyInvoiceView" && hasAuthority("DAILY_INVOICE") && <DailyInvoiceView/>}
        {page === "EmployeeAuthorityManager" && hasAuthority("MANAGE_AUTHORITIES") && <EmployeeAuthorityManager/>}
        {page === "CreateOrder" && hasAuthority("CREATE_ORDER") && <CreateOrder/>}
        {page === "ViewCompleteOrders" && hasAuthority("VIEW_ORDERS") && <ViewCompletedOrders/>}
                        {page === "CostCalculator" &&  <CostCalculator/>}
                {page === "Monthly" &&  <Monthly/>}
                {page === "ProductLedger" &&  <ProductLedger/>}


        {/* Category Pages */}
        {page === 'AddCategory' && hasAuthority("ADD_CATEGORY") && (
          <div className="category-form-container">
            <h2 style={{ color: '#16a34a', marginBottom: '15px' }}>Add New Category</h2>
            <CategoryForm />
          </div>
        )}

        {page === 'ViewCategories' && hasAuthority("VIEW_CATEGORIES") && (
          <div className="view-category-container">
            <h1>View Categories</h1>
            <input
              type="text"
              placeholder="Search category by name..."
              value={searchText}
              onChange={(e) => handleSearchChange(e.target.value)}
              style={{
                width: "50%",
                padding: "10px",
                marginBottom: "20px",
                borderRadius: "6px",
                border: "1px solid #000",
                backgroundColor: "#FFF",
                color: "#000"
              }}
              className='read-only-input'
            />
            <div className="table-scroll-wrapper">
              <table className="purchase-table">
                <thead>
                  <tr style={{color:'#000'}}>
                    <th>Category ID</th>
                    <th>Category Name</th>
                    <th>Products</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCategories.map((cat) => (
                    <tr key={cat.id}>
                      <td>{cat.id}</td>
                      <td>
                        <ul style={{ paddingLeft: '16px', margin: 0, listStyle: 'none' }}>
                          <li>
                            <div>{cat.categoryName}</div>
                            <div style={{ marginTop: '4px', display: 'flex', gap: '6px' }}>
                                <button
                                  style={{
                                    padding: '3px 6px',
                                    backgroundColor: '#16a34a',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '2px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                  }}
                                  onClick={() => {
                                    setEditCategory(cat);
                                    setNewCategoryName(cat.categoryName || '');
                                  }}
                                >
                                  Update
                                </button>
                              
                                <button
                                  style={{
                                    padding: '3px 6px',
                                    backgroundColor: '#dc2626',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '2px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                  }}
                                  onClick={async () => {
                                    if (window.confirm('Are you sure you want to delete this category?')) {
                                      try {
                                        await api.delete(`/api/category/deleteCategories/${cat.id}`);
                                        alert('Category deleted');
                                        fetchCategories();
                                      } catch (err) {
                                        console.error('Delete category failed', err);
                                        alert('Failed to delete category');
                                      }
                                    }
                                  }}
                                >
                                  Delete
                                </button>
                              
                            </div>
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul style={{ paddingLeft: '16px', margin: 0, listStyle: 'none' }}>
                          {(cat.products || []).map((p) => (
                            <li key={p.id} style={{ marginBottom: '10px' }}>
                              <div style={{ fontWeight: 'bold' }}>
                                {p.productName}
                              </div>
                              <div style={{ fontSize: '13px', color: '#333' }}>
                                Purchase: <strong>{p.purchasePrice}</strong> RS <br />
                                Sale: <strong>{p.sellPrice}</strong> RS
                              </div>
                              <div style={{ marginTop: '6px', display: 'flex', gap: '6px' }}>
                                  <button
                                    style={{
                                      padding: '3px 6px',
                                      backgroundColor: '#16a34a',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '2px',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      fontWeight: 'bold'
                                    }}
                                    onClick={() => {
                                      setEditProduct(p);
                                      setNewProductName(p.productName || '');
                                      setNewPurchasePrice(p.purchasePrice ?? '');
                                      setNewSellPrice(p.sellPrice ?? '');
                                    }}
                                  >
                                    Update
                                  </button>
                                
                                  <button
                                    style={{
                                      padding: '3px 6px',
                                      backgroundColor: '#dc2626',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '2px',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      fontWeight: 'bold'
                                    }}
                                    onClick={async () => {
                                      if (window.confirm('Are you sure you want to delete this product?')) {
                                        try {
                                          await api.delete(`/api/category/deleteProductNameAndPrice/${p.id}`);
                                          alert('Product deleted');
                                          fetchCategories();
                                        } catch (err) {
                                          console.error('Delete product failed', err);
                                          alert('Failed to delete product');
                                        }
                                      }
                                    }}
                                  >
                                    Delete
                                  </button>
                                
                              </div>
                            </li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  ))}
                  {filteredCategories.length === 0 && (
                    <tr>
                      <td colSpan="3" style={{ textAlign: 'center', padding: '20px', color: '#ccc' }}>
                        No categories found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Category Update Popup */}
        {editCategory && (
          <div className="popup">
            <div className="popup-content">
              <h3>Update Category</h3>
              <input
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                placeholder="Category Name"
              />
              <div style={{ marginTop: 12 }}>
                <button onClick={updateCategory} style={{ marginRight: 8 }}>Save</button>
                <button onClick={() => setEditCategory(null)}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        {/* Product Update Popup */}
        {editProduct && (
          <div className="popup">
            <div className="popup-content">
              <h3>Update Product</h3>
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                <label style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '4px' }}>Product Name</label>
                <input
                  value={newProductName}
                  onChange={(e) => setNewProductName(e.target.value)}
                  placeholder="Enter Product Name"
                  style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                <label style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '4px' }}>Purchase Price</label>
                <input
                  value={newPurchasePrice}
                  onChange={(e) => setNewPurchasePrice(e.target.value)}
                  placeholder="Enter Purchase Price"
                  type="number"
                  style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                <label style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '4px' }}>Sell Price</label>
                <input
                  value={newSellPrice}
                  onChange={(e) => setNewSellPrice(e.target.value)}
                  placeholder="Enter Sell Price"
                  type="number"
                  style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
                />
              </div>
              <div style={{ marginTop: '12px' }}>
                <button
                  onClick={updateProduct}
                  style={{
                    marginRight: '8px',
                    padding: '6px 12px',
                    backgroundColor: '#16a34a',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => setEditProduct(null)}
                  style={{
                    padding: '6px 12px',
                    backgroundColor: '#dc2626',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default Dashboard;